import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MicIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon">
        <rect id="Rectangle 7288" x="6" y="2" width="4" height="8" rx="2" fill={fillColor || 'white'} />
        <path
          id="Rectangle 7289"
          d="M4.5 6V8C4.5 9.933 6.067 11.5 8 11.5V11.5C9.933 11.5 11.5 9.933 11.5 8V6"
          stroke={fillColor || 'white'}
        />
        <rect id="Rectangle 7290" x="6" y="13" width="4" height="1" fill={fillColor || 'white'} />
      </g>
    </svg>
  );
};

export { MicIcon };
